"use client";

import { useFormStatus } from "react-dom";
import { Button } from "@mui/material";

export default function SubmitButton() {
  const { pending } = useFormStatus();

  return (
    <Button type="submit" variant="contained" disabled={pending}>
      {pending ? "Updating..." : "Confirm"}
    </Button>
  );
}

